import { request as sonataRequest } from 'sonata-react-components';

export const getLQIIndexes = (): Promise<Record<string, any>[]> => {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}lqi/indexes`, {
    method: 'GET',
    params: {
      statuses: 'approved'
    }
  });
};
